// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"d6dd5693","787":"8fce3284"}[chunkId] + ".chunk.js";
};